import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 角色权限
 */
const role = {

  /**
   * 创建
   */
  createRole (name, mountedOn, loginPassword) {
    return axios.post(base.role.createRole, utils.postParamsArrayToJsonString({ name, mountedOn, loginPassword }))
  },
  /**
   * 修改
   */
  modifyRole (roleId, name, mountedOn, loginPassword) {
    return axios.post(base.role.modifyRole, utils.postParamsArrayToJsonString({ roleId, name, mountedOn, loginPassword }))
  },
  /**
   * 删除
   */
  deleteRole (roleId, loginPassword) {
    return axios.post(base.role.deleteRole, utils.postParamsArrayToJsonString({ roleId, loginPassword }))
  },
  /**
   * 查询角色信息
   */
  getRoleInfo (roleId) {
    return axios.post(base.role.getRoleInfo, utils.postParamsArrayToJsonString({ roleId }))
  },
  /**
   * 查询角色信息
   */
  getRolesInfos (companyId) {
    return axios.post(base.role.getRolesInfos, utils.postParamsArrayToJsonString({ companyId }))
  },
  /**
   * 查询角色的子角色
   */
  getChildrenOfRole (roleId, companyId) {
    return axios.post(base.role.getChildrenOfRole, utils.postParamsArrayToJsonString({ roleId, companyId }))
  },
  /**
   * 修改页面权限
   */
  modifyRolePrivilegeForPage (roleId, pages, loginPassword) {
    return axios.post(base.role.modifyRolePrivilegeForPage, utils.postParamsArrayToJsonString({ roleId, pages, loginPassword }))
  },
  /**
   * 获取页面权限
   */
  getRolePrivilegeForPage (roleId, companyId) {
    return axios.post(base.role.getRolePrivilegeForPage, utils.postParamsArrayToJsonString({ roleId, companyId }))
  },
  /**
   * 修改数据权限
   */
  modifyRolePrivilegeForMeasure (roleId, measuresIds, loginPassword) {
    return axios.post(base.role.modifyRolePrivilegeForMeasure, utils.postParamsArrayToJsonString({ roleId, measuresIds, loginPassword }))
  },
  /**
   * 获取数据权限
   */
  getRolePrivilegeForMeasure (roleId) {
    return axios.post(base.role.getRolePrivilegeForMeasure, utils.postParamsArrayToJsonString({ roleId }))
  },
  /**
   * 修改数据权限
   */
  modifyRolePrivilegeForORGStruct (roleId, nodes, loginPassword) {
    return axios.post(base.role.modifyRolePrivilegeForORGStruct, utils.postParamsArrayToJsonString({ roleId, nodes, loginPassword }))
  },
  /**
   * 获取数据权限
   */
  getRolePrivilegeForORGStruct (roleId) {
    return axios.post(base.role.getRolePrivilegeForORGStruct, utils.postParamsArrayToJsonString({ roleId }))
  },
  /**
   * 修改操作权限
   */
  modifyRolePrivilegeForOperation (roleId, privileges, loginPassword) {
    return axios.post(base.role.modifyRolePrivilegeForOperation, utils.postParamsArrayToJsonString({ roleId, privileges, loginPassword }))
  },
  /**
   * 获取操作权限
   */
  getRolePrivilegeForOperation (roleId) {
    return axios.post(base.role.getRolePrivilegeForOperation, utils.postParamsArrayToJsonString({ roleId }))
  },
  /**
   * 列出所有权限操作
   */
  listOperationDefinesOfRolePrivilege () {
    return axios.post(base.role.listOperationDefinesOfRolePrivilege, utils.postParamsArrayToJsonString({}))
  },

  addRolePrivilegeForPage (roleId, pageId, pageParam, loginPassword) {
    return axios.post("/api/addRolePrivilegeForPage", utils.postParamsArrayToJsonString({ roleId, pageId, pageParam, loginPassword }))
  }
}

export default role
